import Swiper from "swiper";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";

export default function QuoteBlockSwiperCarousel() {
  const swiperElement = document.querySelectorAll<HTMLDivElement>(".js-quote-swiper-carousel");

  if (swiperElement && swiperElement.length > 0) {
    Swiper.use([Autoplay, Pagination]);

    swiperElement.forEach((el: HTMLDivElement) => {
      if (el) {
        const carouselEl = el.querySelector<HTMLDivElement>(".swiper");
        const paginationEl = el.querySelector<HTMLButtonElement>(".swiper-pagination");

        if (carouselEl && paginationEl) {
          const speed = carouselEl.getAttribute("data-speed");
          var enabelAutoPlay = true;

          if ( speed && parseInt(speed) <= 0) {
            enabelAutoPlay = false;
          }

          new Swiper(carouselEl, {
            loop: true,
            slidesPerView: 1,
            autoplay: enabelAutoPlay ? {
              delay: speed ? parseInt(speed) : 3000,
              disableOnInteraction: false,
            } : false,
            pagination: {
              el: paginationEl,
              clickable: true,
              type: "bullets",
              renderBullet: function (index, className) {
                // Add descriptive text for each pagination bullet
                return `<button class="${className}" role="button" aria-label="Go to slide ${index + 1}"></button>`;
              },
            },
          });
        }
      }
    });
  }
}
